"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _Row = _interopRequireDefault(require("../../foundational/Layout/Row"));
var _Col = _interopRequireDefault(require("../../foundational/Layout/Col"));
var _Container = _interopRequireDefault(require("../../foundational/Layout/Container"));
var _Section = _interopRequireDefault(require("../Section"));
var _Title = _interopRequireDefault(require("../../atoms/Title"));
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["title", "bgimg", "children", "className", "ariaLabel", "removetitleHr", "showBottomBorder"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
(function _() {
  var styles = ".primary {\n  color: #0a5ec0;\n}\n\n.HeroOverlap {\n  background-position: top center;\n  background-repeat: no-repeat;\n  height: 32.5rem;\n  min-height: 20.625rem;\n  background-size: cover;\n  border-bottom: solid 0.5rem #0a5ec0;\n}\n@media (max-width: 68.75rem) {\n  .HeroOverlap {\n    height: 15rem;\n    min-height: 15rem;\n    width: 100%;\n  }\n}\n.HeroOverlap__container {\n  margin-top: -4.6875rem;\n  background-color: #ffffff;\n  width: 90%;\n  border-bottom: solid 0.05rem #d8d8d8;\n}\n.HeroOverlap__container--noBottomBorder {\n  border-bottom: none;\n}\n@media (max-width: 48rem) {\n  .HeroOverlap__container {\n    margin-top: 0;\n  }\n}";
  var fileName = "HeroOverlap_HeroOverlap";
  var element = document.querySelector("style[data-sass-component='HeroOverlap_HeroOverlap']");
  if (!element) {
    var styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
(function _2() {
  var styles = "";
  var fileName = "HeroOverlap_variables";
  var element = document.querySelector("style[data-sass-component='HeroOverlap_variables']");
  if (!element) {
    var styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
var HeroOverlap = function HeroOverlap(_ref) {
  var title = _ref.title,
    bgimg = _ref.bgimg,
    children = _ref.children,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$ariaLabel = _ref.ariaLabel,
    ariaLabel = _ref$ariaLabel === void 0 ? '' : _ref$ariaLabel,
    _ref$removetitleHr = _ref.removetitleHr,
    removetitleHr = _ref$removetitleHr === void 0 ? false : _ref$removetitleHr,
    _ref$showBottomBorder = _ref.showBottomBorder,
    showBottomBorder = _ref$showBottomBorder === void 0 ? false : _ref$showBottomBorder,
    rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Section["default"], _objectSpread({
      ariaLabel: ariaLabel,
      bgImg: bgimg,
      className: "HeroOverlap ".concat(className)
    }, rest)), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Container["default"], {
      className: "HeroOverlap__container ".concat(!showBottomBorder ? 'HeroOverlap__container--noBottomBorder' : ''),
      as: "section",
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Row["default"], {
        className: "HeroOverlap__row PX-0 PY-3",
        as: "article",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Col["default"], {
          md: 6,
          xs: 6,
          className: "HeroOverlap__column",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Title["default"], {
            showHr: !removetitleHr,
            className: "MB-1H",
            tag: "h1",
            children: title
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Col["default"], {
          md: 6,
          xs: 6,
          children: children
        })]
      })
    })]
  });
};
var _default = HeroOverlap;
exports["default"] = _default;